import { render, staticRenderFns } from "./AppReviewsIcon.vue?vue&type=template&id=c14ec1c6"
import script from "./AppReviewsIcon.vue?vue&type=script&lang=js"
export * from "./AppReviewsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports